import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Schedule: React.FC = () => {
	// ステータスに応じたバリアントの型を修正
	const getStatusVariant = (
		status: string,
	): "default" | "destructive" | "outline" | "secondary" => {
		switch (status) {
			case "募集中":
				return "default";
			case "残りわずか":
				return "destructive";
			case "準備中":
				return "secondary";
			default:
				return "outline";
		}
	};

	const schedules = [
		{
			id: "react-basic",
			date: "2024-04-20",
			time: "14:00-16:00",
			title: "React入門勉強会",
			level: "初級",
			format: "ハイブリッド",
			capacity: "20名",
			status: "募集中",
		},
		{
			id: "python-ds",
			date: "2024-04-27",
			time: "14:00-16:00",
			title: "Pythonデータサイエンス勉強会",
			level: "中級",
			format: "オンライン",
			capacity: "15名",
			status: "残りわずか",
		},
		{
			id: "aws-basic",
			date: "2024-05-11",
			time: "14:00-16:00",
			title: "AWS基礎勉強会",
			level: "初級",
			format: "オンライン",
			capacity: "25名",
			status: "準備中",
		},
	];

	return (
		<section className="py-16 bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-8">開催スケジュール</h2>
				<div className="bg-white rounded-lg shadow overflow-hidden">
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>開催日</TableHead>
								<TableHead>時間</TableHead>
								<TableHead>タイトル</TableHead>
								<TableHead>レベル</TableHead>
								<TableHead>形式</TableHead>
								<TableHead>定員</TableHead>
								<TableHead>状態</TableHead>
								<TableHead />
							</TableRow>
						</TableHeader>
						<TableBody>
							{schedules.map((schedule) => (
								<TableRow key={schedule.id}>
									<TableCell>{schedule.date}</TableCell>
									<TableCell>{schedule.time}</TableCell>
									<TableCell className="font-medium">
										{schedule.title}
									</TableCell>
									<TableCell>
										<Badge variant="outline">{schedule.level}</Badge>
									</TableCell>
									<TableCell>
										<Badge variant="outline">{schedule.format}</Badge>
									</TableCell>
									<TableCell>{schedule.capacity}</TableCell>
									<TableCell>
										<Badge variant={getStatusVariant(schedule.status)}>
											{schedule.status}
										</Badge>
									</TableCell>
									<TableCell>
										<Button
											asChild
											size="sm"
											variant={
												schedule.status === "準備中" ? "outline" : "default"
											}
											disabled={schedule.status === "準備中"}
										>
											<Link to={`/study-groups/${schedule.id}`}>詳細</Link>
										</Button>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
					<p className="text-sm text-gray-500 mt-4">
						※ スケジュールは予告なく変更される場合があります
					</p>
				</div>
			</div>
		</section>
	);
};

export default Schedule;
